module.exports = __webpack_public_path__ + "static/media/house-chimney-medical-solid.ad21b17b.svg";